<section *ngIf="data" class="video-testimonial-panel" #panelEl>

  <div class="video-testimonial-panel__content">

    <h2 *ngIf="data.title" #titleEl>{{ data.title.value }}</h2>
    <h3 *ngIf="data.subtitle" #subtitleEl>{{ data.subtitle.value }}</h3>

    <div class="video-testimonial-panel__carousel v_{{ i }}"
          *ngFor="let item of items; let i = index;"
          [@video]="item.state"
          #carouselEl>
      <div class="video-testimonial-panel__content--grid" *ngIf="item.state === 'active'">
        <button (click)="open()" class="video-testimonial-panel__thumbnail">
          <div class="video-testimonial-panel__thumbnail-img">
            <img src="{{ item.videoData.thumbnail.src }}"
             alt="{{ item.videoData.thumbnail.alt }}"
             loading="lazy"
             [ngStyle]="{aspectRatio: item.videoData?.thumbnail?.width / item.videoData?.thumbnail?.height}" />
          </div>
        </button>
        <app-bg-modal-video *ngIf="item.isShow" [data]="item.videoData" [isShow]="item.isShow" (close)="close()"></app-bg-modal-video>
      </div>
      <app-video-testimonials-reference *ngIf="item.state === 'active'" [item]="item" [loadMedia]="loadMedia"></app-video-testimonials-reference>
    </div>

    <div class="video-picker" [class.video-picker__hide]="itemLength() === 1">
      <div class="video-picker__dots">
        <div class="video-picker__left-arrow" (click)="prevClick()"></div>

        <div *ngFor="let dot of items; let i = index;">
          <div class="video-picker__dots--dot vp_{{ i }}"
               (click)="dotClick(dot, i)"
               [ngClass]="{ 'video-picker__dots--dot-inactive' : dot.state == 'inactive' }"
               [@videoPicker]="dot.state">
          </div>
        </div>

        <div class="video-picker__right-arrow" (click)="nextClick()"></div>
      </div>
    </div>
  </div>

</section>
